import { IconRefresh as Icon } from '@components/icons';
import { Spinner } from './RefreshButton.styles';

interface RefreshButtonProps {
  loading?: string;
}
export const RefreshButton = ({ loading }: RefreshButtonProps) => {
  return (
    <Spinner loading={loading}>
      <Icon />
    </Spinner>
  );
};
